export default "__VITE_ASSET__87a4d5fd__"